export default __webpack_public_path__ + "static/media/Sahiwal01_punnayurkulam_landscape.95da22c8.webp";